import { createRouter, createWebHistory } from 'vue-router';
import { safeRedirectTo } from '../helper/browserNavigation';
import {
  buildRoleWiseRoutes,
  setRoleWiseRoutes,
} from '../helper/roleWiseRoutes';
import { validateLoggedInRoutes } from '../helper/routeHelpers';
import { resolveLandingRoute } from '../helper/landingRoute';
import { CONVERSATION_ROUTE_NAMES } from '../components/layout/config/sidebarItems/conversations';
import { getAppConfigValue } from 'shared/helpers/runtimeConfig';
import { frontendURL } from '../helper/URLHelper';
import { oauthErrorQuery } from '../helper/oauthAuthError';
import store from '../store';
import dashboard from './dashboard/dashboard.routes';

const routes = [...dashboard.routes];
const roleWiseRoutes = setRoleWiseRoutes(buildRoleWiseRoutes(routes));

export const router = createRouter({
  history: createWebHistory(),
  routes,
});

export const validateAuthenticateRoutePermission = (to, next, { getters }) => {
  if (to.name === 'maintenance') {
    return next();
  }

  const { isLoggedIn, getCurrentUser: user } = getters;

  if (!isLoggedIn) {
    // Il deep link (es. il "Vai live" della mail di benvenuto) deve
    // sopravvivere al login: la destinazione viaggia in redirect_url e
    // getLoginRedirectURL la riprende dopo l'autenticazione.
    const requestedPath =
      to?.fullPath && to.fullPath.startsWith('/app/')
        ? `?redirect_url=${encodeURIComponent(to.fullPath)}`
        : '';
    safeRedirectTo(`/app/login${requestedPath}`);
    return '/app/login';
  }

  if (!to.name) {
    // sync-channel riporta qui (`/?auth=error&reason=...`) gli accessi Google o
    // Microsoft falliti senza un account noto: il motivo deve arrivare
    // all'avviso del pannello (OAuthErrorNotice), non perdersi nel redirect.
    return next(
      frontendURL(
        `accounts/${user.account_id}/dashboard`,
        oauthErrorQuery(to.query) || undefined
      )
    );
  }

  const nextRoute = validateLoggedInRoutes(
    to,
    getters.getCurrentUser,
    roleWiseRoutes
  );
  return nextRoute ? next(frontendURL(nextRoute)) : next();
};

export const initalizeRouter = () => {
  const userAuthentication = store.dispatch('setUser');

  router.beforeEach(async (to, from, next) => {
    if (
      getAppConfigValue('MAINTENANCE_MODE', false) &&
      to.name !== 'maintenance'
    ) {
      return next({ name: 'maintenance' });
    }

    if (to.name === 'maintenance') {
      return next();
    }

    return userAuthentication.then(() => {
      // Pagina iniziale scelta dall'utente: vale quando si entra nella sezione
      // conversazioni da fuori. La nuova destinazione ripassa da qui.
      const landingRoute = resolveLandingRoute({
        to,
        from,
        uiSettings: store.getters.getUISettings,
        conversationRouteNames: CONVERSATION_ROUTE_NAMES,
      });
      if (landingRoute) return next(landingRoute);

      return validateAuthenticateRoutePermission(to, next, store);
    });
  });
};

export default router;
